import { MinusCircleOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import React, { useContext, useEffect, useState } from "react";
// import { addReview } from "../../Redux/Actions/CardAction";
// import { useDispatch, useSelector } from "react-redux";
// import { CardContext } from "../../store/CardContext";

const Review = ({ edit }) => {
  // const dispatch = useDispatch();
  // const { review} = useSelector((state) => state.cardReducer);
  const initial = [{ reviewName: "", reviewUrl: "" }]
  const [formValues, setFormValues] = useState([]);
  // const [userContextData, setUserContextData] = useContext(CardContext)

  //   useEffect(()=>{
  //     if(edit&&review[0]?.reviewName){
  //  setFormValues(userContextData.reviews)
  //     }
  //     else{
  //       setFormValues(initial)
  //     }


  //   },[userContextData])
  useEffect(() => {

    setFormValues(initial)



  }, [])

  let handleChange = (i, e) => {
    let newFormValues = [...formValues];
    newFormValues[i][e.target.name] = e.target.value;
    setFormValues(newFormValues);
  };

  // useEffect(() => {
  //   dispatch(addReview(formValues));
  // }, [formValues]);

  let addFormFields = () => {
    setFormValues([...formValues, { reviewName: "", reviewUrl: "" }]);
  };

  let removeFormFields = (i) => {
    let newFormValues = [...formValues];
    newFormValues.splice(i, 1);
    setFormValues(newFormValues);
  };



  return (
    <form >

      {formValues?.map((element, index) => (
        <div className="flex gap-5" key={index}>
          <div>
            <label
              for="first_name"
              className="block mb-2 text-sm font-medium text-gray-900 mt-3"
            >
             Name
            </label>
            <input
              type="text"
              name="Name.."
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-[260px] p-2.5 "
              placeholder=" Review Name"
              value={element?.reviewName || ""}
              onChange={(e) => handleChange(index, e)}
            />
          </div>
          <div>
            <label
              for="first_name"
              className="block mb-2 text-sm font-medium text-gray-900 mt-3"
            >
             Description
            </label>
            <input
              type="text"
              name="reviewUrl"
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-[260px] p-2.5 "
              placeholder="Description.."
              value={element?.reviewUrl || ""}
              onChange={(e) => handleChange(index, e)}
            />
          </div>
          {index ? (
            <button
              type="button"
              className="mt-8"
              onClick={() => removeFormFields(index)}
            >
              <Tooltip placement="top" title="Remove">
                <MinusCircleOutlined
                  style={{ fontSize: "20px", color: "red" }}
                />
              </Tooltip>
            </button>
          ) : (
            <button
              type="button"
              className="mt-8"
              onClick={() => addFormFields()}
            >
              <Tooltip placement="top" title="Add More">
                <PlusCircleOutlined
                  style={{ fontSize: "20px", color: "green" }}
                />
              </Tooltip>
            </button>
          )}
        </div>
      ))}
    </form>

  );
};

export default Review;
